module.exports = __webpack_public_path__ + "img/SL-M-180-260.06680d75.svg";